module.exports = __webpack_public_path__ + "static/media/sa.02710800.svg";